var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsSe = function SvgNnIconFlagsSe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.2 32.2"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1,
    cy: 16.1,
    r: 16,
    fill: "#006dd9",
    stroke: "#bbbcbc",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd500",
    d: "M31.8 12.8H17V.1c-2.27.003-4.81.35-6.67 1.17v11.5H.52c-.459 2.24-.327 4.4 0 6.66h9.81v11.6c1.87.634 4.82 1.49 6.67 1.02v-12.6h14.8c.364-2.73.304-4.4 0-6.67z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1,
    cy: 16.1,
    r: 16,
    fill: "none",
    stroke: "#bbbcbc",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })));
};
export default SvgNnIconFlagsSe;